<template>
  <div>
    <el-dialog custom-class="popup-pos-detail" title="Bỏ giao hàng" :before-close="() => this.$emit('close')" width="600px" :visible.sync="show">
      <div class="body text-center">
        <div class="image" style="height: 120px">
          <img src="@/assets/order-icon/Delivery_hand_nope.png" />
        </div>
        <div class="mt-3" style="margin: 10px 90px;word-break: break-word;">Đơn hàng hiện tại sẽ <b>bị huỷ</b>.Vui lòng tạo lại đơn để bán không giao hàng.</div>
        <div class="infor" v-if="isCustomerPaid">
          <p style="text-align: start;word-break: break-word;">Đơn hàng đã được thanh toán, hãy chắc chắn hoàn tiền cho khách trước khi xác nhận huỷ đơn.</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDelivery" type="primary">Huỷ và tạo đơn mới</el-button>
      </div>
    </el-dialog>

    <!-- loading -->
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { OrdersService } from "@/services/nextshop/orders.service";
import { removeStorageItem } from "@/utils/auth";
import { mapMutations } from "vuex";
import {clonePosData} from '../utils.js'

export default {
  props: ["show", "datas", "DLOid", "isCustomerPaid"],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapMutations("pos", ["SET_INFOR_POS", "SET_ID_POS", "SET_ITEM_POS"]),
    ...mapMutations("sell", ["SET_INFO_SELL", "SET_RM_ID"]),

    async cancelDelivery() {
      // this.addItem();
      // return
      this.loading = true;
      const params = {
        orderId: this.DLOid,
        reason: "",
      };
      // return
      try {
        const res = await OrdersService.cancelBeforeConfirm(params);
        if (res.success) {
          if (this.datas.targetMethod === "SALE_ONLINE_STORE") {
            this.$router.push(`/pos/pos-detail/${this.datas.id}`);
            return;
          }
          // this.orderData.targetMethod === "SALE_ONLINE_STORE"
          this.addItem();
        } else {
          this.showSwalError("Hủy giao hàng", res.message);
        }
      } catch (error) {
        console.log(error);
        this.showSwalError("Hủy giao hàng");
      } finally {
        this.loading = false;
      }
    },
    addItem() {
      const data = {
        activeNegativeInv: false,
        enableInventory: false,
        orders: [],
        paymentChoose: [],
      };
      const itemId = this.$route.params.id;
      const datas = this.outputOrdersData(this.datas);

      const cart = clonePosData(itemId, datas)
      // console.log(22, datas);
      // console.log(cart);
      data.orders.push(cart)
      let feeShip = 0
      let checkShippingFee = datas.lineItemFinalizing.addedFee.find(e => e.key == 'SHIPPING_FEE')
      if(checkShippingFee) {
        feeShip = checkShippingFee.amount
      }
      // tru đi phí ship
      const totalOrder = cart.totalOrder - Math.floor(feeShip)
      cart.totalOrder = +totalOrder
      cart.paymentInfos[0].amount = +totalOrder
      cart.payments = +totalOrder
      // console.log(333, feeShip);
      // return
      removeStorageItem("SELL");
      removeStorageItem('posDloInfo')
      const idUnique = this.getNumberUnique();
      cart.id = idUnique;
      this.SET_RM_ID(0);
      this.SET_INFO_SELL(data)
      this.$router.push("/pos");
    },
  },
};
</script>
<style lang="scss" scoped>
.infor {
  padding: 10px 16px;
  height: 64px;
  background: #fef5e1;
  border-radius: 4px;
}
</style>
